import {
  disableBodyScroll,
  enableBodyScroll
} from "./chunk.WDF6H473.js";
import {
  JbOverlay
} from "./chunk.5C7B4R5Q.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Animatable
} from "./chunk.VRR2P3PQ.js";
import {
  recenterNavItems
} from "./chunk.WXNWU2SV.js";
import {
  h,
  ke
} from "./chunk.FCKNEYTX.js";
import {
  n
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.I4IFG4JG.js";

// src/components/jb-publication-download-overlay/jb-publication-download-overlay.scss?inline
var jb_publication_download_overlay_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
:host {
  color: var(--host-color, #141e55);
}

:host {
  background-color: #fff;
  display: block;
  min-height: 100%;
}

.publication-download-overlay {
  display: block;
  opacity: 0;
  padding-bottom: 80px;
}
@media (min-width: 960px) {
  .publication-download-overlay {
    box-sizing: border-box;
    display: flex;
    flex: 0 1 auto;
    flex-direction: row;
    flex-wrap: wrap;
    margin-left: auto;
    margin-right: auto;
    width: calc(100% - 2 * var(--row-small-margin, 6.68%));
  }
}
@media (min-width: 960px) and (min-width: 600px) and (max-width: 959px) {
  .publication-download-overlay {
    width: calc(100% - 2 * 8.35%);
  }
}
@media (min-width: 960px) and (min-width: 1437px) {
  .publication-download-overlay {
    max-width: var(--row-max-width, 1436px);
  }
  .publication-download-overlay:not(.filtered-list) {
    width: 100%;
  }
}
@media only screen and (min-width: 960px) and (min-width: 960px) and (max-width: 1436px) {
  .publication-download-overlay {
    margin: 0 6.955%;
    max-width: calc(100% - 6.955% - 6.955%);
  }
}`;

// src/components/jb-publication-download-overlay/jb-publication-download-overlay.ts
var JbPublicationDownloadOverlay = class extends Initiable(Animatable(h)) {
  constructor() {
    super(...arguments);
    this.clickCallbackUrl = "";
    this.noLogo = false;
    this.open = false;
    this.withNewsletterSignup = false;
  }
  render() {
    return ke`
      <div class="publication-download-overlay">
        <jb-publication-download
          class="in-overlay"
          .formAction=${this.formAction}
          .clickCallbackUrl=${this.clickCallbackUrl}
          .features=${this.features}
          .picture=${this.picture}
          .link=${this.link}
          .skipDownloadPage=${this.skipDownloadPage}
          .texts=${this.texts}
          .withNewsletterSignup=${this.withNewsletterSignup}
        ></jb-publication-download>
      </div>
    `;
  }
};
JbPublicationDownloadOverlay.styles = r(jb_publication_download_overlay_default);
__decorateClass([
  n()
], JbPublicationDownloadOverlay.prototype, "clickCallbackUrl", 2);
__decorateClass([
  n({ type: Object })
], JbPublicationDownloadOverlay.prototype, "features", 2);
__decorateClass([
  n()
], JbPublicationDownloadOverlay.prototype, "formAction", 2);
__decorateClass([
  n({ type: Object })
], JbPublicationDownloadOverlay.prototype, "link", 2);
__decorateClass([
  n({ type: Boolean })
], JbPublicationDownloadOverlay.prototype, "noLogo", 2);
__decorateClass([
  n({ type: Boolean })
], JbPublicationDownloadOverlay.prototype, "open", 2);
__decorateClass([
  n({ type: Number })
], JbPublicationDownloadOverlay.prototype, "overlayId", 2);
__decorateClass([
  n({ type: Object })
], JbPublicationDownloadOverlay.prototype, "picture", 2);
__decorateClass([
  n({ type: Boolean })
], JbPublicationDownloadOverlay.prototype, "skipDownloadPage", 2);
__decorateClass([
  n({ type: Object })
], JbPublicationDownloadOverlay.prototype, "texts", 2);
__decorateClass([
  n({ type: Boolean })
], JbPublicationDownloadOverlay.prototype, "withNewsletterSignup", 2);
JbPublicationDownloadOverlay = __decorateClass([
  customElement("jb-publication-download-overlay")
], JbPublicationDownloadOverlay);
bindEvents();

// src/components/jb-publication-download-overlay/jb-publication-download-overlay-controller.ts
var JbPublicationDownloadOverlayController = class {
  constructor() {
    this.overlay = void 0;
    this.publicationOverlay = void 0;
  }
  async close() {
    if (this.publicationOverlay) {
      await this.publicationOverlay.hide();
      enableBodyScroll(this.publicationOverlay);
      recenterNavItems();
    }
    if (this.overlay) {
      this.overlay.unstack();
    }
    this.overlay = void 0;
  }
  open(event) {
    const customEvent = event;
    if (!customEvent.detail.publicationOverlay) {
      return;
    }
    customEvent.stopPropagation();
    customEvent.detail.clickEvent.preventDefault();
    customEvent.detail.clickEvent.stopPropagation();
    this.publicationOverlay = new JbPublicationDownloadOverlay().init({
      props: {
        clickCallbackUrl: customEvent.detail.publicationOverlay.clickCallbackUrl,
        features: customEvent.detail.publicationOverlay.features,
        formAction: customEvent.detail.publicationOverlay.formAction,
        link: customEvent.detail.publicationOverlay.link,
        picture: customEvent.detail.publicationOverlay.picture,
        skipDownloadPage: customEvent.detail.publicationOverlay.skipDownloadPage,
        texts: customEvent.detail.publicationOverlay.texts,
        withNewsletterSignup: customEvent.detail.publicationOverlay.withNewsletterSignup
      }
    });
    this.overlay = new JbOverlay().init({
      props: { color: "white", hasLogo: false, hasCloseIcon: true, newAnimation: true },
      childNodes: [this.publicationOverlay]
    });
    if (this.overlay) {
      this.overlay.stack();
      customElements.whenDefined("jb-publication-download-overlay").then(async () => {
        setTimeout(() => {
          this.publicationOverlay.contentChildren = Array.from(
            this.publicationOverlay.shadowRoot.querySelectorAll(".publication-download-overlay")
          );
        }, 0);
        disableBodyScroll(this.publicationOverlay, { allowTouchMove: () => true });
        recenterNavItems();
        await this.publicationOverlay.reveal();
      });
    }
  }
};
var controller = new JbPublicationDownloadOverlayController();
function bindEvents() {
  document.addEventListener("jb-overlay:close", () => {
    controller.close();
  });
  document.addEventListener("jb-link:clicked", (event) => {
    controller.open(event);
  });
}

export {
  bindEvents,
  JbPublicationDownloadOverlay
};
